import { Grid } from "@mui/material";
import React from "react";
import InvestorsHeader from "./home/header";
import InvestorsTable from "./home/table";

const Investors = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <InvestorsHeader />
      </Grid>
      <Grid item xs={12}>
        <InvestorsTable />
      </Grid>
    </Grid>
  );
};

export default Investors;
